var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderMeetings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 1.25V2.5M3.75 1.25V2.5",
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4972 8.125H7.5028M7.4972 10.625H7.5028M9.99439 8.125H10M5 8.125H5.00561M5 10.625H5.00561",
    stroke: "#2177FE",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1875 5H12.8125",
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5625 7.65203C1.5625 4.92871 1.5625 3.56705 2.34507 2.72103C3.12765 1.875 4.38718 1.875 6.90625 1.875H8.09375C10.6128 1.875 11.8724 1.875 12.6549 2.72103C13.4375 3.56705 13.4375 4.92871 13.4375 7.65203V7.97297C13.4375 10.6963 13.4375 12.0579 12.6549 12.904C11.8724 13.75 10.6128 13.75 8.09375 13.75H6.90625C4.38718 13.75 3.12765 13.75 2.34507 12.904C1.5625 12.0579 1.5625 10.6963 1.5625 7.97297V7.65203Z",
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 5H13.125",
    stroke: "#2177FE",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderMeetings);
export default __webpack_public_path__ + "static/media/CalenderMeetings.4a3ba196536711bdbbb4d17c821a9c36.svg";
export { ForwardRef as ReactComponent };